// src/components/common/RouteSeo.js — 개인·관리·결제 화면은 검색 색인 제외 (페이지가 Seo 를 따로 두지 않아도 적용)
import React from 'react';
import { useLocation } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';

const PRIVATE_PATTERNS = [
  /^\/admin(\/|$)/,
  /^\/super-admin(\/|$)/,
  /^\/mypage(\/|$)/,
  /^\/(login|register|forgot-password|reset-password)(\/|$)/,
  /^\/auth\//,
  /^\/checkout(\/|$)/,
  /^\/payment\//,
  /^\/invite(\/|$)/,
  /^\/events\/[^/]+\/order$/,
];

export const isPrivatePath = (pathname) => PRIVATE_PATTERNS.some((re) => re.test(pathname));

const RouteSeo = () => {
  const { pathname } = useLocation();
  if (!isPrivatePath(pathname)) return null;
  return (
    <Helmet>
      <title>게이트온 GATEON</title>
      <meta name="robots" content="noindex,nofollow" />
    </Helmet>
  );
};

export default RouteSeo;
